import { getTokenValue } from '@atlaskit/tokens/get-token-value';

type LayerToken = {
	color: () => string;
	opacity?: number;
};

/** Maps Lottie layer names to the design tokens used to theme them. */
export const layerTokens: Record<string, LayerToken> = {
	'title text': { color: () => getTokenValue('color.text') },
	'title icon': { color: () => getTokenValue('color.icon') },
	'Rectangle 1': { color: () => getTokenValue('elevation.surface') },
	'h1 Header': { color: () => getTokenValue('color.text.subtlest') },
	'h1 description': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'Header white 1': { color: () => getTokenValue('color.text.inverse') },
	Party: { color: () => getTokenValue('color.icon.inverse') },
	'header c1': { color: () => getTokenValue('color.text.inverse') },
	'description c1': { color: () => getTokenValue('color.text.inverse'), opacity: 0.6 },
	Music: { color: () => getTokenValue('color.icon.subtlest') },
	Cloud: { color: () => getTokenValue('color.icon.subtlest') },
	Blocks: { color: () => getTokenValue('color.icon.subtlest') },
	'header c2': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'description c2': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'header c3': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'description c3': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'header c4': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'description c4': { color: () => getTokenValue('color.text.subtlest'), opacity: 0.6 },
	'card purple 1 (skeleton)': { color: () => getTokenValue('color.icon.subtlest') },
	'card gray 1': { color: () => getTokenValue('color.background.accent.gray.subtlest') },
	'card gray 2': { color: () => getTokenValue('color.background.accent.gray.subtlest') },
	'card gray 3': { color: () => getTokenValue('color.background.accent.gray.subtlest') },
	Background: { color: () => getTokenValue('elevation.surface') },
};
